import { AlertInfoSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import stylesProgress from './progresscard.module.scss';
import { CategoryType } from '../../../shared/components/CategoryLabel/models';
import './keyframe-animations.css';

function getType(productType: string) {
  if (productType === 'eLearning') {
    return 'course';
  }

  return productType.toLowerCase();
}

export default function PendingMessage({ type }: { type: CategoryType }) {
  return (
    <div className={`${stylesProgress.pendingCourse} mt-4`}>
      <AlertInfoSolidIcon fontSize="sm" className="me-2" />
      <div className={stylesProgress.ellipsesAnimated}>
        You have enrolled! Your {getType(type)} is now processing
        <span className="dot1">.</span>
        <span className="dot2">.</span>
        <span className="dot3">.</span>
      </div>
    </div>
  );
}
